import { autoinject, computedFrom, transient } from "aurelia-framework";
import { EmailRecipientTypeEnum, SubtaskCorrespondenceEmailModel } from "../../../../../models/vetting/vetting.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipOnboardingService } from "../../../../../services/rightship-onboarding/rightship-onboarding.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { OnboardingRequestDocumentModel } from "../../../../../models/onboarding/onboarding.models";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";
import { NotifyPropertyChangedBase, Reflection } from "../../../../../utilities/reflection";

@autoinject()
@transient()
export class EmailFormDialog extends NotifyPropertyChangedBase{
    public message: string;
    private onboardingRequestGuid: string;
    public documents: OnboardingRequestDocumentModel[];
    public attachFormResponseCSV: boolean = true;

    emails: SubtaskCorrespondenceEmailModel[] = [];

    public constructor(private i18N: I18N,
        private dialogClientService: DialogClientService,
        private notificationService: NotificationClientService,
        private rightShipOnboardingService: RightShipOnboardingService) {

            super();
         }

    public cancel() {
        this.dialogClientService.hide();
    }

    activate(model) {
        this.onboardingRequestGuid = model.onboardingRequestGuid;
        this.documents = CloneHelper.cloneObject(model.documents);
        //default to all selected
        this.selectAll();
        this.rightShipOnboardingService.getRecipientsForRequestEmailForm(this.onboardingRequestGuid).then(defEmails => {
            if (defEmails.length > 0) {
                defEmails.forEach(email => {
                    this.emails.push({
                        email: email.email,
                        emailRecipientTypeId: email.emailRecipientTypeId
                    });
                });
            } else {
                this.addEmail();
            }
        });
    }

    public save(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const request = {
                message: this.message,
                onboardingRequestGuid: this.onboardingRequestGuid,
                emails: this.emails.map(x => {
                    return {
                        emailRecipientTypeId: x.emailRecipientTypeId,
                        email: x.email
                    }
                }),
                documents: this.documents.filter(x => x["isSelected"] == true),
                attachFormResponseCSV: this.attachFormResponseCSV
            }

            this.rightShipOnboardingService.sendFormAttachmentsEmail(request).then(() => {
                this.dialogClientService.hide();
                this.notificationService.show(this.i18N.tr('success-text'), "", NotificationType.Success);
                resolve();
            }).catch(e => {
                if (e?.content?.exception != 'GenesisException') {
                    this.notificationService.show(this.i18N.tr('error-text'), "Could not send the email", NotificationType.Error);
                }
                reject();
            });
        });
    }

    removeEmail(i) {
        this.emails.splice(i, 1);
    }

    addEmail() {
        this.emails.push({
            email: "",
            isFromConfig: false,
            emailRecipientTypeId: EmailRecipientTypeEnum.To
        });
    }

    toggleCSVAttachment() {
        this.attachFormResponseCSV = !this.attachFormResponseCSV;
    }


    toggleDocumentSelection(index: number) {
        this.documents[index]["isSelected"] = !this.documents[index]["isSelected"];
        this.onPropertyChanged<EmailFormDialog>(x => x.documents);
        
    }

    @computedFrom(Reflection.getPropertyPath<EmailFormDialog>(z => z.documents),
        Reflection.getPropertyPath<EmailFormDialog>(z => z.changes.documents),
        Reflection.getPropertyPath<EmailFormDialog>(z => z.documents.length),
        Reflection.getPropertyPath<EmailFormDialog>(z => z.attachFormResponseCSV),
        Reflection.getPropertyPath<EmailFormDialog>(z => z.attachFormResponseCSV))
    get allSelected() {
        return this.documents && this.documents.length > 0 && this.documents.filter(d => !d["isSelected"]).length == 0 && this.attachFormResponseCSV;
    }

    selectAll() {
        if (this.allSelected) {
            this.attachFormResponseCSV = false;
            this.documents.forEach(d => {
                d["isSelected"] = false;
            });
        }
        else {
            this.attachFormResponseCSV = true;
            this.documents.forEach(d => {
                d["isSelected"] = true;
            });
        }
    }
}